export function normalizeAutomarkerData(data) {
    return data.filter((e) => e.group.name);
}
